import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Login from './login';
import ResetPass from './resetPass';

export default function OpenRoutes() {
  return (
    <Router>
      <Switch>
        <Route path="/reset-password">
          <ResetPass />
        </Route>
        <Route path="/" exact>
          <Login />
        </Route>
        <Route render={() => <Redirect to={{ pathname: '/' }} />} />
      </Switch>
    </Router>
  );
}
